import React from 'react';
import styled from 'styled-components';
import ShopCard from '../ShopCard/ShopCard';
import Grid from '../Grid/Grid';
import { CAROUSEL, DOM_MY_ZONE_DROPDOWN } from '../../../../lib/constants';
import { makeExternalUrl } from '../../../../lib/utils';
import MaxWidthLayout from '../../../templates/MaxWidthLayout';
import { saveShop, removeShopById } from '../../../../lib/user';
import {
  getMyZoneUtilityLinkProps,
  MY_ZONE_SHOP_TRACKING_LOCATION,
} from './myZoneNavigationAnalytics';

const MyZoneDiv = styled.div`
  background-color: ${p => p.theme.c.bg.primary};
  box-shadow: 0 2px 8px 0 ${({ theme }) => theme.c.border['box-shadow']};
  border: solid 1px ${({ theme }) => theme.c.border.primary};
  text-align: left;
  width: 100vw;
  margin-top: ${p => p.theme.unit(1)};
`;

const MyZoneContentDiv = styled.div`
  display: flex;
  flex-direction: row;
`;

const AnchorPaddingDiv = styled.div`
  padding: 0 ${p => p.theme.unit(3)};
  :hover {
    text-decoration: none;
    background-color: ${p => p.theme.c.bg.secondary};
  }
`;

const DropdownEntryAnchor = styled.a`
  display: inline-flex;
  align-items: center;
  height: ${p => p.theme.unit(5)};
  width: 100%;
  text-decoration: none;
  cursor: pointer;
`;

const IconImg = styled.img`
  width: ${p => p.theme.unit(3)};
  padding-right: ${p => p.theme.unit(1)};
`;

const TitleSpan = styled.span`
  ${({ theme }) => theme.typographyRebrand.body.md}
  color: ${p => p.theme.c.text.interactive};
  min-width: ${p => p.theme.unit(18)};
  padding-top: 2px; // to center text
  text-decoration: none;
  :hover {
    color: ${p => p.theme.c.text['interactive-hover']};
    text-decoration: underline;
  }
`;

const LeftSectionDiv = styled.div`
  display: flex;
  flex-direction: column;
`;

const LeftSectionPaddingDiv = styled.div`
  padding: ${p => p.theme.unit(3)} 0;
`;

const RightSectionPaddingDiv = styled.div`
  ${({ theme }) => theme.typographyRebrand.body.md}
  color: ${p => p.theme.c.text.primary};
  width: 100%;
  padding: ${p => p.theme.unit(4.5)} 0;
`;

const LeftSectionLink = (props) => {
  const {
    text,
    analyticsSlug,
    url,
    icon,
    locale,
  } = props;

  const resolvedIconUrl = makeExternalUrl(icon);
  const trackingProps = getMyZoneUtilityLinkProps({ analyticsSlug, url, locale });

  return (
    <AnchorPaddingDiv>
      <DropdownEntryAnchor
        {...trackingProps}>
        <IconImg src={resolvedIconUrl} alt="" />
        <TitleSpan>{text}</TitleSpan>
      </DropdownEntryAnchor>
    </AnchorPaddingDiv>
  );
};


const MyZoneDropdown = (props) => {
  const {
    myZoneDropdownTitle,
    dropdownEntries,
    userShopsData,
    locale,
    pageStateModifiers,
  } = props;

  const leftSection = dropdownEntries ? (
    <LeftSectionPaddingDiv>
      <LeftSectionDiv>
        {dropdownEntries.map((entry, index) => {
          const key = `entry-${index}`;
          return (
            <LeftSectionLink key={key} {...entry} locale={locale} />
          );
        })}
      </LeftSectionDiv>
    </LeftSectionPaddingDiv>
  ) : null;

  let itemsToDisplay = userShopsData && userShopsData.length ?
    userShopsData.slice(0, 4) : [];

  itemsToDisplay = itemsToDisplay.map((i) => {
    return {
      ...i,
      isFavourite: true,
      dataContextContainer: DOM_MY_ZONE_DROPDOWN,
      pageContext: DOM_MY_ZONE_DROPDOWN,
      trackingLocation: MY_ZONE_SHOP_TRACKING_LOCATION,
    };
  });

  const rightSection = itemsToDisplay &&  itemsToDisplay.length ? (
    <RightSectionPaddingDiv>
      {myZoneDropdownTitle || null}
      <Grid
        items={itemsToDisplay}
        Comp={ShopCard}
        removeItemHandler={removeShopById}
        saveItemHandler={saveShop}
        pageStateModifiers={pageStateModifiers}
        locale={locale}
        itemSize={CAROUSEL}
        hideWrappedItems
      />
    </RightSectionPaddingDiv>
  ) : null;

  return (
    <MyZoneDiv>
      <MaxWidthLayout>
        <MyZoneContentDiv>
          {leftSection}
          {rightSection}
        </MyZoneContentDiv>
      </MaxWidthLayout>
    </MyZoneDiv>
  );
};

export default MyZoneDropdown;
